/**
 * TokenSavingsPage — Ahorro de tokens (Gobernanza; REQ-CHAT-039 §2/§7).
 *
 * Movido desde Settings → LLM Policy (19-Oct-2026): el panel es una vista de
 * gobierno/coste, no de configuración de política. Ámbito tenant (admin).
 */

import { useTenant } from '@/contexts/TenantContext';
import { TokenSavingsPanel } from '@/features/llm-config/components/TokenSavingsPanel';

export function TokenSavingsPage() {
  const { currentTenant } = useTenant();

  return (
    <div className="space-y-6 max-w-5xl" data-testid="token-savings-page">
      <TokenSavingsPanel tenantId={currentTenant?.id} />
    </div>
  );
}

export default TokenSavingsPage;
